import { useCallback, useEffect, useState } from 'react';
import {
    Card,
    Stack,
    Snackbar,
    Link,
    Grid,
    Typography,
    Alert,
    Skeleton,
    Button,
    Radio,
    RadioGroup,
    FormControlLabel,
    TextField,
    Tooltip,
    IconButton,
    Select,
    MenuItem,
    FormControl,
    FormHelperText
} from '@mui/material';
import moment from 'moment';
import { Input, DateInputField } from "components";
import Autocomplete, { createFilterOptions } from '@mui/material/Autocomplete';
import {
    InputLabel, RightAlignButton, ButtonAlign, ButtonAlignLeft,
    InlineButton, InlineButtonSize
} from '../../home/Home-components';
import {
    standardQuoteSearch,
    saveStandardQuote,
    standardQuotePriceList,
    addAssociateFee,
    addQuotesTestInfo,
    updateQuote,
    updateAssociateFeeApi,
    getQuotesList,
    getContacts,
    getAnalysisList,
    getResultTableNames,
    getResultTableData,
    generatePdfFile,
    shareWithCustomerApi,
    newClientPriceList,
    getClientOnboardingStates,
    getASMBasedStateId,
    getASMUser,
} from 'services';
import { Breadcrumb } from 'components';
import { AssociateFees, AnalysisFees } from '../module/StandardQuote';
import { useSearchParams, useNavigate } from 'react-router';
import ClickAwayListener from '@mui/material/ClickAwayListener';
import { ShareWithCustomer } from '../components';
import { ApproveConfirmationBox } from '../module/StandardQuote/InnerComponent';
import InfoOutlinedIcon from '@mui/icons-material/InfoOutlined';
import ArticleOutlinedIcon from '@mui/icons-material/ArticleOutlined';
import IosShareOutlinedIcon from '@mui/icons-material/IosShareOutlined';
import SaveAsOutlinedIcon from '@mui/icons-material/SaveAsOutlined';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import useFetch from '../../customHooks/useFetch';

let startDateCheck: any = '';
let validToCheck: any = '';
let updateAssociateFeeListId: any = '';
let quoteId: any;
let priceTableResult: any = [];
let updateQuoteResult: any = [];
let resultTableNames: any = [];
let clientDetails: any = {};
let updateAssociateFeeQuote: any = false;
let chargesStatus: any = false;

const ALPHA_NUMERIC_DASH_REGEX = /^[ A-Za-z0-9_@./&+-]*$/;
const htmlTag = /<[^>]*>/g;

export const StandardQuote = () => {
    let navigate = useNavigate();
    const [searchparams] = useSearchParams();
    let isEdit = searchparams.get('status') !== null;
    let paramId = searchparams.get('id');
    let isClient = searchparams.get('client');
    const [searchValue, setSearchValue] = useState('');
    const [priceListName, setPriceListName] = useState('');
    const [withoutClientPriceList, setWithoutClientPriceList] = useState('');
    const [getPriceListId, setGetPriceListId] = useState('');
    const [clientId, setClientId] = useState('');
    const [projectName, setProjectName] = useState('');
    const [projectStartDate, setProjectStartDate] = useState('');
    const [projectValidTo, setProjectValidTo] = useState('');
    const [clientName, setClientName] = useState('');
    const [withOutClientName, setWithOutClientName] = useState('');
    const [reportStateId, setReportStateId] = useState('');
    const [reportStateList, setReportStateList] = useState([] as any[]);
    const [analysisFeeResponse, setAnalysisFeeResponse] = useState([]);
    const [isEditStartDate, setIsEditStartDate] = useState('');
    const [isEditValidtDate, setIsEditValidtDate] = useState('');
    const [inputValue, setInputValue] = useState(null);
    const [emailId, setEmailId] = useState('');
    const [deliverToPhone, setDeliverToPhone] = useState('');
    const [itemList, setItemList] = useState([] as any[]);
    const [associateFeeList, setAssociateFeeList] = useState({});
    const [quoteNumber, setQuoteNumber] = useState([] as any[]);
    const [editQuoteNumber, setEditQuoteNumber] = useState([] as any[]);
    const [attentionId, setAttentionId] = useState(0);
    const [attentionToName, setAttentionToName] = useState<any>()
    const [contactList, setContactList] = useState([] as any[]);
    const [attentionContactName, setAttentionContactName] = useState('');
    const [attentionContactEmail, setAttentionContactEmail] = useState('');
    const [attentionContactPhone, setAttentionContactPhone] = useState('');
    const [attentionContactMobile, setAttentionContactMobile] = useState('');
    const [attentionContactEmailError, setAttentionContactEmailError] = useState('');
    const [attentionContactPhoneError, setAttentionContactPhoneError] = useState('');
    const [attentionContactMobileError, setAttentionContactMobileError] = useState('');
    const [attentionContactNameError, setAttentionContactNameError] = useState('');
    const [isFromLocation, setIsFromLocation] = useState([] as any[]);
    const [newPriceList, setNewPriceList] = useState([] as any[]);
    const [description, setDescription] = useState<any>();
    const [contactName, setContactName] = useState<any>();
    const [contactEmailId, setContactEmailId] = useState<any>();
    const [contactPhoneNo, setContactPhoneNo] = useState<any>();
    const [contactId, setContactId] = useState<any>();
    const [courierChargeList, setCourierChargeList] = useState([] as any[]);;
    const [updateChargeList, setUpdateChargeList] = useState([] as any[]);
    const [editApproveStatus, setEditApproveStatus] = useState(false);
    const [editApproveMessage, setEditApproveMessage] = useState(false);
    const [contactPhoneNoError, setContactPhoneNoError] = useState('');
    const [commonError, setCommonError] = useState({
        message: '',
        open: false
    });
    const [nameError, setNameError] = useState({
        required: '',
        htmlError: ''
    });
    const [serviceEmail, setServiceEmail] = useState({
        required: '',
        htmlError: ''
    });
    const [nameWithoutClientError, setNameWithoutClientError] = useState({
        required: '',
        htmlError: ''
    });
    const [reportStateError, setReportStateError] = useState({
        required: '',
    });
    const [attentionWithoutClientError, setAttentionWithoutClientError] = useState({
        required: '',
        htmlError: ''
    });
    const [emailError, setEmailError] = useState({
        required: '',
        validError: ''
    });
    const [deliverToPhoneError, setDeliverToPhoneError] = useState({
        required: '',
        validError: ''
    });
    const [attentionEmptyError, setAttentionEmptyError] = useState(false);
    const [isShareWithCustomer, setIsShareWithCustomer] = useState(false);
    const [saveAllTrigger, setSaveAllTrigger] = useState(0);
    const [isSuccessMsg, setIsSuccessMsg] = useState(false);
    const [duplicateError, setDuplicateError] = useState({
        status: false,
        message: ''
    });
    const [addTestStatus, setAddTestStatus] = useState({
        status: false,
        message: ''
    });
    const [resultTableStatus, setResultTableStatus] = useState(false);
    const [disableSearchResult, setDisableSearchResult] = useState(false);
    const [summaryUpdateStatus, setSummaryUpdateStatus] = useState(false);
    const [showSummaryTable, setShowSummaryTable] = useState(false);
    const [loading, setLoading] = useState(true);
    const [isValidTo, setIsValidTo] = useState(false);
    const [isStartDate, setIsStartDate] = useState(false);
    const [quoteSuccess, setQuoteSuccess] = useState(false);
    const [analysisFeeStatus, setAnalysisFeeStatus] = useState(false);
    const [downloadSuccess, setDownloadSuccess] = useState(false);
    const [isServiceContact, setIsServiceContact] = useState(false);
    const [isAssociateError, setIsAssociateError] = useState(false);
    const [isContactEmailIdError, setIsContactEmailIdError] = useState('');
    const [asmOptions, setAsmOptions] = useState([] as any[]);
    const [selectedAsmId, setSelectedAsmId] = useState<any>('');
    const [signatureAsmError, setSignatureAsmError] = useState('');
    const [userInfo] = useFetch();
    const [error, setError] = useState(false);
    const [errorMessage, setErrorMessage] = useState();

    const isProd = window.location.origin.includes('elvisconnect.eurofinsanz.com');

    useEffect(() => {
        if (searchValue.length >= 3) {
            searchClient(searchValue);
        } else {
            searchClient([]);
        }
        if (isClient === 'new') {
            newClientPriceList().then((res: any) => {
                setNewPriceList(res.data);
            });
            getClientOnboardingStates().then((res: any) => {
                if (res.status === 200) {
                    setReportStateList(res.data);
                } else {
                    setReportStateList([]);
                    setError(true);
                    setErrorMessage(res.data?.message);
                }
            });
        }
    }, [searchValue, isClient])

    useEffect(() => {
        if (isEdit) {
            getQuotesList(paramId).then((res: any) => {
                if (res.status === 200) {
                    clientDetails = res.data;
                    let objA: any = {
                        'addressToName': res.data.addressToName,
                        'id': clientDetails.id
                    }
                    setClientName(objA);
                    updateQuoteResult.push(res.data);
                    quoteId = res.data.id;
                    setSearchValue(clientDetails.clientInfo.name);
                    setEditQuoteNumber(res.data?.quoteNumber);
                    setPriceListName(res.data?.priceListName);
                    setGetPriceListId(res.data?.priceListID);
                    setProjectName(res.data?.projectName);
                    setIsEditStartDate(res.data?.projectStartDate);
                    setIsEditValidtDate(res.data?.projectValidTo);
                    setClientId(res.data?.clientID);
                    setEmailId(res.data?.deliverToEmail);
                    setDeliverToPhone(res.data?.deliverToPhone);
                    setAttentionId(res.data?.addressTo);
                    setAttentionContactName(res.data?.quotesContactInfo?.name);
                    setAttentionContactEmail(res.data?.quotesContactInfo?.email);
                    setAttentionContactPhone(res.data?.quotesContactInfo?.phone);
                    setAttentionContactMobile(res.data?.quotesContactInfo?.mobile);
                    setAttentionToName(res.data?.addressToName);
                    getContactList(res.data?.clientID);
                    setEditApproveStatus(res.data?.status === 3);
                    setDescription(res.data?.description);
                    setWithoutClientPriceList(res.data?.priceListName);
                    setWithOutClientName(res.data?.newClientName);
                    setReportStateId(res.data?.stateID);
                    setIsServiceContact(res.data?.hasServiceContact);
                    setShowSummaryTable(res.data?.ShowSummaryTable ?? res.data?.showSummaryTable ?? false);
                    setContactName(res.data?.serviceContact?.name);
                    setContactEmailId(res.data?.serviceContact?.emailID);
                    setContactPhoneNo(res.data?.serviceContact?.phoneNo);
                    setContactId(res.data?.serviceContact?.id);
                    validateNameInput(res.data?.serviceContact?.name)
                    validateServiceEmailId(res.data?.serviceContact?.emailID);
                    setSelectedAsmId(res.data?.signatureUserID ?? '');
                } else {
                    setEditApproveStatus(false);
                }
            });

            analysisGridLoad(paramId);

            getResultTableNames(paramId).then((res: any) => {
                if (res.status === 200) {
                    resultTableNames = res.data;
                    setResultTableStatus(true);
                }
            });

            getResultTableData(paramId).then((res: any) => {
                if (res.status === 200) {
                    priceTableResult = res.data;
                }
            });
        } else {
            resetTheApp();
        }
    }, [isEdit])

    const resetTheApp = () => {
        resultTableNames = [];
        updateQuoteResult = [];
        priceTableResult = [];
        quoteId = '';
        setResultTableStatus(false);
        setAnalysisFeeStatus(false);
        setIsServiceContact(false);
        setShowSummaryTable(false);
        setDisableSearchResult(false);
        setAnalysisFeeResponse([]);
        setItemList([]);
        setEditQuoteNumber([]);
        setDescription('');
        setContactName('');
        setContactPhoneNo('');
        setWithOutClientName('');
        setAttentionToName('');
        setEmailId('');
        setDeliverToPhone('');
        setPriceListName('');
        setProjectName('');
        setInputValue(null);
        setSelectedAsmId('');
        setSignatureAsmError('');
    }

    useEffect(() => {
        resetTheApp();
    }, [paramId, isClient])

    useEffect(() => {
        chargesStatus = false;
        return () => {
            resetTheApp();
        };
    }, []);

    const analysisGridLoad = useCallback(async (paramId: any) => {
        try {
            setLoading(true);
            setAnalysisFeeResponse([]);
            if (paramId) {
                await getAnalysisList(paramId).then((res: any) => {
                    if (res.status === 200) {
                        let response = res.data;
                        response.sort((a, b) => b.id - a.id);
                        setAnalysisFeeResponse(prevData => {
                            if (JSON.stringify(prevData) !== JSON.stringify(response)) {
                                return response;
                            }
                            return prevData;
                        });
                        setAnalysisFeeStatus(true);
                    }
                });
            }
        } catch (error: any) {
            // error;
        } finally {
            setLoading(false);
        }
    }, [])

    const searchClient = (val: any) => {
        if (val.length >= 3 && !isEdit) {
            setLoading(true);
            standardQuoteSearch(val).then((res: any) => {
                if (res.status === 200) {
                    let itList: any = [];
                    res.data.map((el: any) => {
                        let obj = {
                            id: el.id,
                            name: el.name,
                            label: el.name,
                            code: el.code,
                            priceListId: el.priceListID,
                            status: el.includeHandlingCharges,
                            buCode: el.buCode
                        }
                        itList.push(obj)
                    })
                    setItemList(itList);
                    setLoading(false);
                }
            }).finally(() => {
                setLoading(false);
            })
        } else if (val.length === 0) {
            setItemList([]);
            setLoading(false);
        }
    }

    const getPriceList = (id: any) => {
        if (!id) return;
        standardQuotePriceList(id).then((res: any) => {
            if (res.status === 200) {
                setPriceListName(res.data.name);
                setGetPriceListId(res.data.id);
            }
        }).finally(() => {
            setLoading(false)
        })
    }

    const getContactList = (clientId: any) => {
        if (clientId) {
            getContacts(clientId).then((res: any) => {
                if (res.status === 200) {
                    setContactList(res.data);
                    if (isEdit) {
                        const result = res.data.find((item: any) => item.id === clientDetails?.addressTo);
                        setInputValue(result);
                        setClientName((current: any) => ({
                            ...current,
                            addressToName: result?.name || current?.addressToName || ''
                        }));
                    }
                }
            }).finally(() => {
                setLoading(false)
            })
        }
    }

    const handleSubmit = (val: any) => {
        if ((quoteNumber.length !== 0) || (editQuoteNumber.length !== 0)) {
            updateQuoteTest(val);
        } else {
            initialQuoteSubmit(val);
        }
    }

    const initialQuoteSubmit = (val: any) => {
        let isValid = (isClient === 'exist') ? (searchValue && priceListName && validToCheck) : (validToCheck);
        if (isValid && getPriceListId) {
            let saveObj = {
                "clientID": isClient === 'exist' ? clientId : -1,
                "priceListID": getPriceListId,
                "projectName": projectName,
                "projectStartDate": startDateCheck ? moment(startDateCheck).format("YYYY/MM/DD") : '1900/01/01',
                "projectValidTo": validToCheck ? moment(validToCheck).format("YYYY/MM/DD") : '1900/01/01',
                "CreatedBy": userInfo ? userInfo.id : null,
                "AddressTo": isClient === 'exist' ? attentionId : -1,
                "AddressToName": isClient === 'new' ? attentionToName : '',
                "DeliverToEmail": isClient === 'new' ? emailId : '',
                "DeliverToPhone": isClient === 'new' ? deliverToPhone : '',
                "description": description,
                "quoteForNewClient": isClient === 'new',
                "newClientName": isClient === 'new' ? withOutClientName : '',
                "stateID": isClient === 'new' ? reportStateId : '',
                "HasServiceContact": !!isServiceContact,
                "ShowSummaryTable": !!showSummaryTable,
                "SignatureUserID": signatureUserId,
            }
            if (isClient === 'exist') {
                saveObj['QuotesContactInfo'] = {
                    "contactID": attentionId,
                    "name": attentionContactName,
                    "email": attentionContactEmail,
                    "phone": attentionContactPhone,
                    "mobile": attentionContactMobile
                }
            }
            if (isServiceContact) {
                saveObj['serviceContact'] = {
                    "name": contactName,
                    "phoneNo": contactPhoneNo,
                    "emailID": contactEmailId
                }
            }
            saveStandardQuote(saveObj).then((res: any) => {
                if (res.status === 200) {
                    if (val !== 'priceList') {
                        setQuoteSuccess(true);
                    }
                    quoteId = res.data.id;
                    let objB: any = {
                        'addressToName': inputValue?.name,
                        'id': quoteId
                    }
                    setClientName(objB);
                    setQuoteNumber(res.data.quoteNumber);
                    associateFeeSubmit(associateFeeList, res.data.id, val);
                    setContactName(res.data?.serviceContact?.name);
                    setContactEmailId(res.data?.serviceContact?.emailID);
                    setContactPhoneNo(res.data?.serviceContact?.phoneNo);
                    setContactId(res.data?.serviceContact?.id);
                    updateQuoteResult.push(res.data);
                    setDisableSearchResult(true);
                }
            }).finally(() => {
                setLoading(false)
            })
        }
    }

    const redirectPage = () => {
        return setTimeout(() => {
            navigate('/home/viewQuote')
        }, 3000);
    }

    const updateQuoteTest = (val: any) => {
        if (editApproveStatus) {
            setEditApproveMessage(true);
        } else {
            updateQuoteApi(val);
        }
    }

    const updateQuoteApi = (val: any) => {
        let updateObj: any;
        if (updateQuoteResult) {
            updateQuoteResult.map((item: any) => {
                updateObj = {
                    "id": item.id,
                    "quoteNumber": item.quoteNumber,
                    "clientID": isClient === 'exist' ? item.clientID : -1,
                    "priceListID": item.priceListID,
                    "projectName": projectName,
                    "projectStartDate": startDateCheck ? moment(startDateCheck).format("YYYY/MM/DD") : '1900/01/01',
                    "projectValidTo": validToCheck ? moment(validToCheck).format("YYYY/MM/DD") : '1900/01/01',
                    "createdBy": item.createdBy,
                    "createdOn": item.createdOn,
                    "status": item.status,
                    "AddressTo": isClient === 'exist' ? attentionId : -1,
                    "AddressToName": isClient === 'new' ? attentionToName : '',
                    "DeliverToEmail": isClient === 'new' ? emailId : '',
                    "DeliverToPhone": isClient === 'new' ? deliverToPhone : '',
                    "description": description,
                    "quoteForNewClient": isClient === 'new',
                    "newClientName": isClient === 'new' ? withOutClientName : '',
                    "stateID": isClient === 'new' ? reportStateId : '',
                    "HasServiceContact": !!isServiceContact,
                    "ShowSummaryTable": !!showSummaryTable,
                    "SignatureUserID": signatureUserId,
                    "updatedBy": item.updatedBy,
                    "updatedOn": item.updatedOn
                }
            })
        }
        if (isClient === 'exist') {
            updateObj['QuotesContactInfo'] = {
                "id": clientDetails?.quotesContactInfo?.id,
                "contactID": attentionId,
                "quoteId": isEdit ? clientDetails?.id : quoteId,
                "name": attentionContactName,
                "email": attentionContactEmail,
                "phone": attentionContactPhone,
                "mobile": attentionContactMobile
            }
        }
        if (isServiceContact) {
            updateObj['serviceContact'] = {
                "ID": contactId,
                "QuoteID": isEdit ? clientDetails?.id : quoteId,
                "name": contactName,
                "phoneNo": contactPhoneNo,
                "emailID": contactEmailId
            }
        }
        updateQuote(updateObj).then((res: any) => {
            if (res.status === 200) {
                if (val !== 'priceList') {
                    setQuoteSuccess(true);
                }
                associateFeeSubmit(associateFeeList, res.data.id, val);
                quoteId = res.data.id;
                setQuoteNumber(res.data.quoteNumber);
                updateQuoteResult.push(res.data);
            }
        }).finally(() => {
            setLoading(false)
        })
    }

    const associateFeeSubmit = (associateFeeList: any, id: any, submitType: any) => {
        if ((quoteNumber.length !== 0) || (editQuoteNumber?.length !== 0)) {
            updateAssociateQuote(associateFeeList, id, submitType);
        } else {
            associateFeeQuote(associateFeeList, id, submitType);
        }
    }

    const associateFeeQuote = (associateFeeList: any, id: any, submitType: any) => {
        if (associateFeeList) {
            let createArr = genericCourierCharges(associateFeeList?.courierCharges);
            let feeObj = {
                "hasHandlingCharge": associateFeeList?.hasHandlingCharge,
                "handlingCharge": associateFeeList?.hasHandlingCharge ? associateFeeList?.handlingCharge : 0,
                "hasSplitCourierCharge": associateFeeList?.hasSplitCourierCharge,
                "splitCourierCharge": associateFeeList?.hasSplitCourierCharge ? associateFeeList?.splitCourierCharge : 0,
                "hasCourierChargeToLab": associateFeeList?.hasCourierChargeToLab,
                "courierCharges": createArr,
                "hasCourierChargeForContainer": associateFeeList?.hasCourierChargeForContainer,
                "courierChargeForContainer": associateFeeList?.courierChargeForContainer,
                "cccFromLabID": associateFeeList?.cccFromLabID,
                "cccToLab": associateFeeList?.cccToLab,
                "quoteID": id
            }
            addAssociateFee(feeObj).then((res: any) => {
                if (res.status === 200) {
                    updateAssociateFeeQuote = true;
                    updateAssociateFeeListId = res.data.id;
                    setUpdateChargeList(res.data.courierCharges);
                    if (submitType === 'isSubmitButton') {
                        redirectPage();
                    }
                    setIsAssociateError(false);
                } else if (res.status === 400) {
                    setIsAssociateError(true);
                }
            }).finally(() => {
                setLoading(false)
            })
        }
    }

    const updateAssociateQuote = (associateFeeList: any, id: any, submitType: any) => {
        if (associateFeeList && updateAssociateFeeListId) {
            let chargeItem = [...courierChargeList];
            updateChargeList.forEach((obj2: any) => {
                const index = chargeItem.findIndex((obj1: any) => obj1.toLocationID === obj2.toLocationID);
                let match = chargeItem.find((itemB: any) => itemB.toLocationID === obj2.toLocationID);
                if (index !== -1) {
                    obj2.amount = match.amount;
                    chargeItem[index] = obj2;
                } else {
                    chargeItem.push(obj2);
                }
            })

            let updateCharge = genericCourierCharges(chargeItem);

            let feeObj = {
                "id": updateAssociateFeeListId,
                "hasHandlingCharge": associateFeeList?.hasHandlingCharge,
                "handlingCharge": associateFeeList.hasHandlingCharge ? associateFeeList?.handlingCharge : 0,
                "hasCourierChargeToLab": associateFeeList?.hasCourierChargeToLab,
                "courierCharges": updateCharge,
                "hasCourierChargeForContainer": associateFeeList?.hasCourierChargeForContainer,
                "courierChargeForContainer": associateFeeList?.hasCourierChargeForContainer ? associateFeeList?.courierChargeForContainer : 0,
                "hasSplitCourierCharge": associateFeeList?.hasSplitCourierCharge,
                "splitCourierCharge": associateFeeList?.hasSplitCourierCharge ? associateFeeList?.splitCourierCharge : 0,
                "cccFromLabID": associateFeeList?.cccFromLabID,
                "cccToLab": associateFeeList?.cccToLab,
                "quoteID": id
            }
            updateAssociateFeeApi(feeObj).then((res: any) => {
                if (res.status === 200) {
                    setUpdateChargeList(res.data.courierCharges);
                    if (submitType === 'isSubmitButton') {
                        redirectPage();
                    }
                    setIsAssociateError(false);
                } else if (res.status === 400) {
                    setIsAssociateError(true);
                }
            }).finally(() => {
                setLoading(false)
            })
        }
    }

    const genericCourierCharges = (item: any) => {
        let updateArr: any = [];
        item?.map((i: any) => {
            let obj: any = {};
            if (i.isTestLab) {
                obj = {
                    fromLocation: isFromLocation,
                    toLocationID: i.toLocationID,
                    amount: i.amount
                }
            } else {
                obj = {
                    fromLocation: isFromLocation,
                    toLocationID: i.toLocationID,
                    amount: i.amount,
                    id: i.id
                }
            }
            updateArr.push(obj);
        })
        return updateArr
    }

    const updateAssociateFee = (val: any) => {
        setAssociateFeeList(val);
    }

    const getAssociateId = (val: any) => {
        updateAssociateFeeListId = val;
    }

    const updateAddStatus = (val: any) => {
        const { status } = val;
        setEditApproveMessage(false);
        setEditApproveStatus(false);
        if (status && quoteNumber.length === 0) {
            handleSubmit('isAddSubmit');
            setTimeout(() => {
                handleSubmitTest(val)
            }, 2000);
        } else {
            handleSubmitTest(val);
        }
    }

    const summaryStatus = (val: any) => {
        setShowSummaryTable(!!val);
        if (val) {
            setSummaryUpdateStatus(true);
        }
    }

    const handleSubmitTest = (val: any) => {
        if (quoteId !== '') {
            let obj = {
                "quoteID": quoteId,
                "testIDs": val?.testIDs,
                "matrixTypeID": val?.matrixTypeID,
                "billingGroupID": val?.billingGroupID,
                "priceListID": val?.priceListID,
                "quotesTestGroupID": val?.quotesTestGroupID
            }
            addQuotesTestInfo(obj).then((res: any) => {
                if (res.status === 200) {
                    setAnalysisFeeStatus(true);
                    let data: any = res.data;
                    data.map((i: any) => {
                        i['isErrorBorder'] = (i.testPrice === 0);
                    });
                    data.sort((a, b) => b.id - a.id);
                    setAnalysisFeeResponse(data);
                    setAddTestStatus({ status: true, message: 'Test added successfully!' });
                    setDuplicateError({ status: false, message: '' });
                }
                else if (res.status === 400) {
                    setDuplicateError({ status: true, message: res.data });
                }
            }).finally(() => {
                setLoading(false)
            })
        }
    }

    const handleProjectName = (ev: any) => {
        let newValue = ev.target.value;
        setProjectName(newValue);
    }

    const validateNameInput = (receivedValue: any) => {
        let newErrors: any = { required: '', htmlError: '' };
        if (receivedValue === 'true' || receivedValue?.trim() === '') {
            newErrors.required = 'Name is required';
        }
        if (htmlTag.test(receivedValue)) {
            newErrors.htmlError = 'Not a valid input!'
        }
        setNameError(newErrors);
    }

    const handleWithoutClientName = (cname: any) => {
        setWithOutClientName(cname);
        validateWithoutClientName(cname);
    }

    const handleReportState = (val: any) => {
        setReportStateId(val);
        validateWithoutClientReportState(val);
    }

    const validateWithoutClientName = (receivedValue: any) => {
        let newErrors: any = { required: '', htmlError: '' };
        if (receivedValue?.trim() === '') {
            newErrors.required = 'Client Name is required';
        }
        if (htmlTag.test(receivedValue)) {
            newErrors.htmlError = 'Not a valid input!'
        }
        setNameWithoutClientError(newErrors);
    }

    const validateWithoutClientReportState = (receivedValue: any) => {
        let newErrors: any = { required: '' };
        if (receivedValue === '' || receivedValue === null || receivedValue === undefined) {
            newErrors.required = 'State is required';
        }
        setReportStateError(newErrors);
    }

    const handleAttentionTo = (val: any) => {
        setAttentionToName(val);
        validateWithoutAttentionTo(val);
    }

    const validateWithoutAttentionTo = (receivedValue: any) => {
        let newErrors: any = { required: '', htmlError: '' };
        if (receivedValue?.trim() === '') {
            newErrors.required = 'Attention To is required';
        }
        if (htmlTag.test(receivedValue)) {
            newErrors.htmlError = 'Not a valid input!'
        }
        setAttentionWithoutClientError(newErrors);
    }

    const quoteMessageClose = (itemStatus: any) => {
        if (itemStatus) {
            setQuoteSuccess(false);
        } else {
            setDuplicateError({ status: false, message: '' });
        }
    }

    const getPriceTableResult = (val: any) => {
        if (val) {
            setResultTableStatus(true);
        }
    }

    const parentGetRow = (val: any) => {
        if (val) {
            val.map((i: any) => {
                priceTableResult.push(i);
            });
        }
    }

    const handleShareWithCustomer = (content: any) => {
        shareWithCustomerApi(content).then((res: any) => {
            if (res.status === 200) {
                setIsSuccessMsg(true);
                setIsShareWithCustomer(false);
            } else {
                setIsShareWithCustomer(true);
            }
        })
    }

    let currentDate: any;
    if (projectStartDate) {
        currentDate = projectStartDate;
    } else {
        currentDate = new Date().toJSON().slice(0, 10)
    }

    const getDate = new Date(currentDate);
    let endDate: any = getDate.setFullYear(getDate.getFullYear() + 1);
    let validToDate: any = new Date(endDate).toJSON().slice(0, 10);

    if (isEdit) {
        startDateCheck = moment(isEditStartDate).format("yyyy-MM-DD");
    } else if (isStartDate) {
        startDateCheck = projectStartDate;
    } else {
        startDateCheck = currentDate;
    }

    if (isEdit) {
        validToCheck = moment(isEditValidtDate).format("yyyy-MM-DD");
    } else if (isValidTo) {
        validToCheck = projectValidTo;
    } else {
        validToCheck = validToDate;
    }

    let submitCheck: any = false;
    let isRequired: any = searchValue && priceListName && validToCheck && attentionId;
    let isNewClient: any = (withoutClientPriceList && validToCheck && (attentionToName?.length > 0) && withOutClientName?.length > 0 && (reportStateId !== '' && reportStateId !== null && reportStateId !== undefined) && (emailId?.length > 0) && emailError.required === '' && emailError.validError === '');
    let errorCheck: any = serviceEmail.required === '' && serviceEmail.htmlError === '' && isContactEmailIdError === '' && nameError.required === '' && nameError.htmlError === '' && attentionContactEmailError === '' && attentionContactPhoneError === '' && attentionContactMobileError === '' && attentionContactNameError === '' && signatureAsmError === '';
    let newClientError: any = nameWithoutClientError.required === '' && nameWithoutClientError.htmlError === '' && reportStateError.required === '' && attentionWithoutClientError.required === '' && attentionWithoutClientError.htmlError === '';
    const signatureUserId: any = selectedAsmId;
    const isSignatureValid: boolean = (!!selectedAsmId && !signatureAsmError);
    if (isClient === 'exist') {
        submitCheck = !!(isRequired && errorCheck && isSignatureValid)
    } else {
        submitCheck = !!(isNewClient && errorCheck && newClientError && isSignatureValid);
    }

    let nameList: any = '';
    if (clientDetails.clientInfo) {
        nameList = `${clientDetails.clientInfo.name} - ${clientDetails.clientInfo.code}`;
    }

    const handleClickAway = () => {
        //console block
    };

    const handleGenerate = () => {
        handleSubmit('isGeneratePdf');
        setTimeout(() => {
            generatePdf();
        }, 4000);
    }

    // Save first so the dialog picks up the latest client/attention names.
    const handleShareClick = () => {
        handleSubmit('isShareWithCustomer');
        setTimeout(() => {
            setIsShareWithCustomer(true);
        }, 4000);
    }

    // Flush the Result Page "Save All" edits before saving the quote itself.
    const handleSaveDraft = () => {
        setSaveAllTrigger(prev => prev + 1);
        setTimeout(() => {
            handleSubmit('isSubmitButton');
        }, 2000);
    }

    const generatePdf = () => {
        if (quoteId) {
            generatePdfFile(quoteId)
                .then((res: any) => {
                    if (res.status === 200) {
                        setDownloadSuccess(true);
                        const linkSource = `data:application/pdf;base64,${res.data}`;
                        const downloadLink = document.createElement("a");
                        let quoteNo = isEdit ? editQuoteNumber : quoteNumber;
                        const fileName = `${quoteNo}.pdf`;
                        downloadLink.href = linkSource;
                        downloadLink.download = fileName;
                        downloadLink.click();
                    } else if (res.status === 400) {
                        setCommonError({
                            message: res.data || 'Something went wrong while generating the PDF.',
                            open: true
                        });
                    }
                }).catch((error: any) => {
                    setCommonError({
                        message:
                            error?.response?.data ||
                            error?.message ||
                            "Something went wrong while generating the PDF.",
                        open: true,
                    });
                })
                .finally(() => {
                    setLoading(false)
                })
        }
    }

    const getLabList = (val: any) => {
        setIsFromLocation(val);
    }

    const updateItemStatus = (val: any) => {
        chargesStatus = val;
    }

    const isValidEmail = (email: any) => {
        return /\S+@\S+\.\S+/.test(email);
    }

    const handleEmailIdChange = (val: any) => {
        setEmailId(val);
        hanldeEmailOnBlur(val);
    };

    const hanldeEmailOnBlur = (val: any) => {
        let newErrors: any = { required: '', validError: '' };
        if (val.length > 0) {
            if (val !== '' && !isValidEmail(val)) {
                newErrors.validError = 'Email Id Is Invalid';
            }
        } else {
            newErrors.required = 'Email Id is required';
        }
        setEmailError(newErrors);
    }

    const handleDeliverToPhoneChange = (val: any) => {
        if (val === '' || /^[\d\s+()]*$/.test(val)) {
            setDeliverToPhone(val);
            hanldeDeliverToPhoneOnBlur(val);
        }
    };

    const hanldeDeliverToPhoneOnBlur = (val: any) => {
        let newErrors: any = { required: '', validError: '' };
        if (val?.replace(/\D/g, '').length > 20) {
            newErrors.validError = 'Phone number must not exceed 20 digits';
        }
        setDeliverToPhoneError(newErrors);
    }

    const handleServiceContact = (e: any) => {
        if (e.target.value === 'true') {
            setIsServiceContact(true);
        } else {
            setIsServiceContact(false);
            setContactName('');
            setContactPhoneNo('');
            setContactEmailId('');
        }
        validateNameInput(e.target.value);
        validateServiceEmailId(e.target.value);
    }

    // Fetches ASM options (used for the Signature Contact "Custom" dropdown) by report state.
    useEffect(() => {
        getASMUser().then((res: any) => {
            if (res?.status === 200) {
                setAsmOptions(res.data.users || []);
            } else {
                setAsmOptions([]);
            }
        }).catch(() => {
            setAsmOptions([]);
        });
    }, []);

    useEffect(() => {
        if (selectedAsmId) {
            setSignatureAsmError('');
        } else {
            setSignatureAsmError('Please select the ASM');
        }
    }, [selectedAsmId]);

    useEffect(() => {
        if (!asmOptions?.length || !userInfo?.id || selectedAsmId) {
            return;
        }

        const matchingAsm = asmOptions.find(
            (option: any) => String(option.id) === String(userInfo.id)
        );

        if (matchingAsm) {
            setSelectedAsmId(matchingAsm.id);
        }
    }, [asmOptions, userInfo?.id, selectedAsmId]);

    const handleAsmSelect = (e: any) => {
        const value = e.target.value;

        setSelectedAsmId(value);

        if (value) {
            setSignatureAsmError('');
        } else {
            setSignatureAsmError('Please select the ASM');
        }
    };

    const handlePhoneNo = (ev: any) => {
        const newValue = ev.target.value;

        if (/^[\d\s+()]*$/.test(newValue)) {
            setContactPhoneNo(newValue);

            setContactPhoneNoError(
                newValue.replace(/\D/g, '').length > 20
                    ? 'Phone number must not exceed 20 digits'
                    : ''
            );
        }
    };

    const handleServiceEmailId = (event: any) => {
        if (event.target.value !== '' && !isValidEmail(event.target.value)) {
            setIsContactEmailIdError('Email Id Is Invalid');
        } else {
            setIsContactEmailIdError('');
        }
        setContactEmailId(event.target.value);
        validateServiceEmailId(event.target.value);
    }

    const validateServiceEmailId = (receivedValue: any) => {
        let newErrors: any = { required: '', htmlError: '' };
        if (receivedValue === 'true' || receivedValue?.length === 0) {
            newErrors.required = 'Email Id is required';
        }
        if (htmlTag.test(receivedValue)) {
            newErrors.htmlError = 'Not a valid input!'
        }
        setServiceEmail(newErrors);
    }

    let nav: any = [
        { name: 'Home', path: '/home/viewQuote' },
        { name: 'Quote', path: '/home/viewQuote' },
        { name: `Generate Quote ${isClient === 'exist' ? 'for a Client' : ''}`, path: '/home/generateQuote' }
    ];

    return (
        <div>
            <div style={{ display: 'flex', justifyContent: 'space-between', padding: '16px 0', cursor: 'pointer' }}>
                <Breadcrumb navList={nav} />
            </div>
            <Typography variant="h6" gutterBottom align='left' mb={2} color="secondary.main">
                Generate Quote {isClient === 'exist' ? 'for a Client' : ''}
            </Typography>
            {isEdit ?
                <RightAlignButton>
                    <Typography variant="h6" gutterBottom align='right' mr={4} color="secondary.main">
                        Quote Number: {editQuoteNumber}
                    </Typography>
                </RightAlignButton>
                : null}
            <Card variant="outlined" sx={{ padding: 4 }}>
                <Typography variant="h6" data-testid="clientcard" gutterBottom mt={2} mb={6} color="secondary.main">
                    Client and Project Details
                </Typography>
                <ClickAwayListener
                    mouseEvent="onMouseDown"
                    touchEvent="onTouchStart"
                    onClickAway={handleClickAway}
                >
                    <Grid container spacing={3}>
                        {isClient === 'exist' ?
                            <>
                                <Grid item xs={4} sm={3} md={3} style={{ paddingTop: 0 }}>
                                    <InputLabel>
                                        <Typography variant="subtitle1" gutterBottom>
                                            Client <span style={{ color: "#f00" }}> *</span>
                                        </Typography>
                                    </InputLabel>
                                </Grid>
                                <Grid item xs={8} sm={9} md={9} style={{ paddingTop: 0 }}>
                                    <Stack spacing={2} sx={{ width: { xs: '14ch', sm: '38ch', md: '51ch' }, paddingLeft: 1 }}>
                                        {isEdit ?
                                            <Input
                                                disabled
                                                id="outlined-disabled"
                                                label=""
                                                value={nameList}
                                                size="small"
                                            />
                                            : <Autocomplete
                                                freeSolo
                                                id="free-solo-2-demo"
                                                disableClearable
                                                size="small"
                                                sx={{
                                                    '.MuiOutlinedInput-root input': {
                                                        padding: '2px'
                                                    }
                                                }}
                                                options={itemList}
                                                noOptionsText="No Options"
                                                disabled={disableSearchResult || isEdit}
                                                onChange={(event: any, newValue: any) => {
                                                    getPriceList(newValue.priceListId);
                                                    getContactList(newValue.id);
                                                    chargesStatus = newValue.status;
                                                    setClientId(newValue.id);
                                                    if (newValue) {
                                                        setTimeout(() => {
                                                            if (attentionId !== 0) {
                                                                setAttentionEmptyError(false);
                                                            } else {
                                                                setAttentionEmptyError(true);
                                                            }
                                                        }, 800)
                                                    }
                                                }}
                                                onInputChange={(event, newInputValue, reason) => {
                                                    if (reason === 'input') {
                                                        // User is typing
                                                        setSearchValue(newInputValue);
                                                    }

                                                    if (newInputValue.length === 0) {
                                                        setPriceListName('');
                                                        setProjectName('');
                                                        chargesStatus = false;
                                                    }
                                                }}
                                                filterOptions={createFilterOptions({
                                                    stringify: ({ name, code, buCode }) => `${name} ${code} ${buCode}`,
                                                })}
                                                getOptionLabel={(option) => {
                                                    if (typeof option === 'string') return option;
                                                    return `${option.name} - ${option.code} - ${option.buCode}`;
                                                }}
                                                renderInput={(params) => (
                                                    <TextField
                                                        {...params}
                                                        inputProps={{
                                                            ...params.inputProps,
                                                            type: 'search'
                                                        }}
                                                    />
                                                )}
                                            />
                                        }
                                    </Stack>
                                </Grid>
                            </>
                            : null}
                        {loading ? <>
                            <Grid item xs={2} sm={3} md={3} style={{ paddingTop: 0 }}>
                                <Skeleton height={60} width={200} />
                            </Grid>
                            <Grid item xs={10} sm={9} md={9} style={{ paddingTop: 0 }}>
                                <Skeleton height={60} width={562} style={{ marginLeft: '8px' }} />
                            </Grid>
                            <Grid item xs={2} sm={3} md={3} style={{ paddingTop: 0 }}>
                                <Skeleton height={60} width={200} />
                            </Grid>
                            <Grid item xs={10} sm={9} md={9} style={{ paddingTop: 0 }}>
                                <Skeleton height={60} width={562} style={{ marginLeft: '8px' }} />
                            </Grid>
                            <Grid item xs={2} sm={3} md={3} style={{ paddingTop: 0 }}>
                                <Skeleton height={60} width={200} />
                            </Grid>
                            <Grid item xs={10} sm={9} md={9} style={{ paddingTop: 0 }}>
                                <Skeleton height={60} width={562} style={{ marginLeft: '8px' }} />
                            </Grid>
                            <Grid item xs={2} sm={3} md={3} style={{ paddingTop: 0 }}>
                                <Skeleton height={60} width={200} />
                            </Grid>
                            <Grid item xs={10} sm={9} md={9} style={{ paddingTop: 0 }}>
                                <Skeleton height={60} width={562} style={{ marginLeft: '8px' }} />
                            </Grid>
                            <Grid item xs={2} sm={3} md={3} style={{ paddingTop: 0 }}>
                                <Skeleton height={60} width={200} />
                            </Grid>
                            <Grid item xs={10} sm={9} md={9} style={{ paddingTop: 0 }}>
                                <Skeleton height={60} width={562} style={{ marginLeft: '8px' }} />
                            </Grid>
                            <Grid item xs={2} sm={3} md={3} style={{ paddingTop: 0 }}>
                                <Skeleton height={60} width={200} />
                            </Grid>
                            <Grid item xs={10} sm={9} md={9} style={{ paddingTop: 0 }}>
                                <Skeleton height={60} width={562} style={{ marginLeft: '8px' }} />
                            </Grid>
                        </> : <>
                            <Grid item xs={4} sm={3} md={3} style={{ paddingTop: '6px' }}>
                                <InputLabel>
                                    <Typography variant="subtitle1" gutterBottom>
                                        Price List <span style={{ color: "#f00" }}> *</span>
                                    </Typography>
                                </InputLabel>
                            </Grid>
                            <Grid item xs={8} sm={9} md={9} style={{ paddingTop: 12, paddingBottom: 0, paddingLeft: 22 }}>
                                <Typography variant="body1" display="block">
                                    {(isClient === 'exist') ? <span style={{ paddingLeft: 16, fontSize: '12px' }}>{(priceListName || '--')}</span> :
                                        <Stack spacing={2} sx={{ width: { xs: '16ch', sm: '44ch', md: '59.5ch' }, paddingLeft: 1, paddingBottom: '10px' }}>
                                            {(isEdit || disableSearchResult) ? <Input
                                                disabled
                                                id="outlined-disabled"
                                                label=""
                                                value={priceListName}
                                                size="small"
                                            />
                                                : <Autocomplete
                                                    freeSolo
                                                    id="free-solo-2-demo"
                                                    disableClearable
                                                    size="small"
                                                    options={newPriceList}
                                                    noOptionsText="No Options"
                                                    onChange={(event: any, newValue: any) => {
                                                        setGetPriceListId(newValue?.id);
                                                        setPriceListName(newValue?.name);
                                                        if (isClient === 'new') {
                                                            if (newValue) {
                                                                handleWithoutClientName(withOutClientName);
                                                                handleReportState(reportStateId);
                                                                handleAttentionTo(attentionToName);
                                                                handleEmailIdChange(emailId);
                                                                if (attentionId !== 0) {
                                                                    setAttentionEmptyError(false);
                                                                } else {
                                                                    setAttentionEmptyError(true);
                                                                }
                                                            }
                                                        }
                                                    }}
                                                    onInputChange={(event: any, newInputValue: any) => {
                                                        setWithoutClientPriceList(newInputValue);
                                                    }}
                                                    filterOptions={createFilterOptions({
                                                        stringify: ({ name }) => `${name} `,
                                                    })}
                                                    getOptionLabel={(option) => {
                                                        if (typeof option === 'string') return option;
                                                        return option.name || '';
                                                    }}
                                                    renderInput={(params) => (
                                                        <TextField
                                                            {...params}
                                                            inputProps={{
                                                                ...params.inputProps,
                                                                type: 'search'
                                                            }}
                                                        />
                                                    )}
                                                />}
                                        </Stack>
                                    }
                                </Typography>
                            </Grid>
                            <Grid item xs={4} sm={3} md={3} style={{ paddingTop: 10 }}>
                                <InputLabel>
                                    <Typography variant="subtitle1" gutterBottom>
                                        Project Name
                                    </Typography>
                                </InputLabel>
                            </Grid>
                            <Grid item xs={8} sm={9} md={9} style={{ paddingTop: 0, paddingLeft: 22 }}>
                                <Input
                                    id="outlined-adornment-weight"
                                    sx={{ m: 1, width: { xs: '14ch', sm: '38ch', md: '51ch' } }}
                                    aria-describedby="outlined-weight-helper-text"
                                    onChange={handleProjectName}
                                    value={projectName}
                                    inputProps={{
                                        'aria-label': 'weight',
                                        defaultValue: projectName
                                    }}
                                    onKeyDown={(event) => {
                                        if (!ALPHA_NUMERIC_DASH_REGEX.test(event.key)) {
                                            event.preventDefault();
                                        }
                                    }}
                                    size="small"
                                    required
                                />
                            </Grid>
                            <Grid item xs={4} sm={3} md={3} style={{ paddingTop: '6px' }}>
                                <InputLabel>
                                    <Typography variant="subtitle1" gutterBottom>
                                        Project Start Date
                                    </Typography>
                                </InputLabel>
                            </Grid>
                            <Grid item xs={8} sm={9} md={9} style={{ paddingTop: 8, paddingBottom: 8, paddingLeft: 30 }}>
                                <DateInputField
                                    value={startDateCheck}
                                    onChange={(iso) => { setProjectStartDate(iso); setIsStartDate(true); }}
                                    sx={{ width: { xs: '14ch', sm: '38ch', md: '51ch' } }}
                                    size="small"
                                />
                            </Grid>
                            <Grid item xs={4} sm={3} md={3} style={{ paddingTop: '6px' }}>
                                <InputLabel>
                                    <Typography variant="subtitle1" gutterBottom>
                                        Quote Valid To <span style={{ color: "#f00" }}> *</span>
                                    </Typography>
                                </InputLabel>
                            </Grid>
                            <Grid item xs={8} sm={9} md={9} style={{ paddingTop: 8, paddingBottom: 8, paddingLeft: 30 }}>
                                <DateInputField
                                    value={validToCheck}
                                    onChange={(iso) => { setProjectValidTo(iso); setIsValidTo(true); }}
                                    sx={{ width: { xs: '14ch', sm: '38ch', md: '51ch' } }}
                                    size="small"
                                    error={validToCheck < startDateCheck}
                                    helperText={validToCheck < startDateCheck ? 'Enter a valid Date' : ''}
                                />
                            </Grid>
                            {isClient === 'new' ?
                                <>
                                    <Grid item xs={4} sm={3} md={3} style={{ paddingTop: '10px' }}>
                                        <InputLabel>
                                            <Typography variant="subtitle1" gutterBottom>
                                                Client Name <span style={{ color: "#f00" }}> *</span>
                                                <Tooltip title="Client(Company) Name">
                                                    <InfoOutlinedIcon sx={{ position: 'absolute', height: '14px', paddingTop: '4px' }} />
                                                </Tooltip>
                                            </Typography>
                                        </InputLabel>
                                    </Grid>
                                    <Grid item xs={8} sm={9} md={9} style={{ paddingTop: 0, paddingLeft: '22px' }}>
                                        <TextField
                                            id="outlined-adornment-weight"
                                            sx={{ m: 1, width: { xs: '14ch', sm: '38ch', md: '51ch' } }}
                                            aria-describedby="outlined-weight-helper-text"
                                            value={withOutClientName}
                                            onChange={(e: any) => handleWithoutClientName(e.target.value)}
                                            size="small"
                                            error={!!nameWithoutClientError.required || !!nameWithoutClientError.htmlError}
                                            helperText={nameWithoutClientError.required || nameWithoutClientError.htmlError}
                                        />
                                    </Grid>
                                    <Grid item xs={4} sm={3} md={3} style={{ paddingTop: '10px' }}>
                                        <InputLabel>
                                            <Typography variant="subtitle1" gutterBottom>
                                                State <span style={{ color: "#f00" }}> *</span>
                                            </Typography>
                                        </InputLabel>
                                    </Grid>
                                    <Grid item xs={8} sm={9} md={9} style={{ paddingTop: 0, paddingLeft: '22px' }}>
                                        <FormControl
                                            size="small"
                                            error={!!reportStateError.required}
                                            disabled={isEdit || disableSearchResult}
                                            sx={{
                                                m: 1,
                                                width: { xs: '14ch', sm: '38ch', md: '51ch' },
                                            }}
                                        >
                                            <Select
                                                value={reportStateId}
                                                onChange={(e) => handleReportState(e.target.value)}
                                                displayEmpty
                                                sx={{ fontSize: 12 }}
                                            >
                                                {reportStateList.map((option) => (
                                                    <MenuItem key={option.id} value={option.id}>
                                                        {option.name}
                                                    </MenuItem>
                                                ))}
                                            </Select>

                                            <FormHelperText>
                                                {reportStateError.required}
                                            </FormHelperText>
                                        </FormControl>
                                    </Grid>
                                </>
                                : null}
                            <Grid item xs={4} sm={3} md={3} style={{ paddingTop: '8px' }}>
                                <InputLabel>
                                    <Typography variant="subtitle1" gutterBottom>
                                        Attention To <span style={{ color: "#f00" }}> *</span>
                                    </Typography>
                                </InputLabel>
                            </Grid>
                            <Grid item xs={8} sm={9} md={9} style={{ paddingTop: '8px', paddingLeft: 30 }}>
                                {isClient === 'exist' ?
                                    <Autocomplete
                                        options={contactList.filter(
                                            (item, index, self) => index === self.findIndex((t) => t.id === item.id)
                                        )}
                                        value={inputValue}
                                        getOptionLabel={(option) => option.name || ''}
                                        onChange={(event: any, newValue: any) => {
                                            setAttentionId(newValue?.id || 0);
                                            setInputValue(newValue);
                                            setClientName((current: any) => ({
                                                ...current,
                                                addressToName: newValue?.name
                                            }));
                                            if (newValue) {
                                                setAttentionEmptyError(false);
                                                setAttentionContactName(newValue?.name || newValue?.contactName || newValue?.userName || '');
                                                setAttentionContactEmail(newValue?.emailAddress || newValue?.email || newValue?.emailId || newValue?.emailID || '');
                                                setAttentionContactPhone(newValue?.phoneNo || newValue?.phone || newValue?.phoneNumber || '');
                                                setAttentionContactMobile(newValue?.mobileNumber || newValue?.mobile || newValue?.mobileNo || '');
                                                setAttentionContactEmailError('');
                                                setAttentionContactPhoneError('');
                                                setAttentionContactMobileError('');
                                            }
                                        }}
                                        filterOptions={(options, { inputValue }) => {
                                            const filteredOptions = options.filter((option) =>
                                                option.name.toLowerCase().includes(inputValue.toLowerCase())
                                            );

                                            return filteredOptions.filter(
                                                (item, index, self) => index === self.findIndex((t) => t.id === item.id)
                                            );
                                        }}
                                        noOptionsText="No matching options"
                                        sx={{
                                            width: { xs: '14ch', sm: '38ch', md: '51ch' },
                                            '.MuiAutocomplete-clearIndicator': {
                                                display: 'none',
                                            },
                                        }}
                                        size="small"
                                        renderOption={(props, option) => (
                                            <li {...props} key={option.id}>
                                                {option.name}
                                            </li>
                                        )}
                                        renderInput={(params) => (
                                            <TextField
                                                {...params}
                                                label=""
                                                inputProps={{
                                                    ...params.inputProps,
                                                    type: 'search',
                                                }}
                                                error={attentionEmptyError}
                                                helperText={attentionEmptyError ? "Attention To is required" : null}
                                            />
                                        )}
                                    />
                                    :
                                    <TextField
                                        id="outlined-adornment-weight"
                                        sx={{ width: { xs: '14ch', sm: '38ch', md: '51ch' } }}
                                        value={attentionToName}
                                        onChange={(e: any) => handleAttentionTo(e.target.value)}
                                        inputProps={{
                                            'aria-label': 'weight',
                                            defaultValue: attentionToName
                                        }}
                                        size="small"
                                        onKeyDown={(event) => {
                                            if (!ALPHA_NUMERIC_DASH_REGEX.test(event.key)) {
                                                event.preventDefault();
                                            }
                                        }}
                                        error={!!attentionWithoutClientError.required || !!attentionWithoutClientError.htmlError}
                                        helperText={attentionWithoutClientError.required || attentionWithoutClientError.htmlError}
                                    />
                                }
                                {inputValue && isClient === 'exist' && (
                                    <Grid container spacing={2}
                                        sx={{ width: { xs: '14ch', sm: '38ch', md: '51.5ch' }, marginTop: "15px", border: '1px solid #ddd', padding: '20px', marginLeft: '0px' }}
                                    >
                                        <Grid item xs={12} sm={6} md={6} style={{ paddingTop: '10px', display: 'inline-flex', paddingLeft: 0 }}>
                                            <Input
                                                sx={{ width: '24.5ch' }}
                                                placeholder='Name'
                                                value={attentionContactName}
                                                onChange={(e: any) => {
                                                    setAttentionContactName(e.target.value);
                                                    setAttentionContactNameError(
                                                        e.target.value.length > 50 ? 'Name cannot exceed 50 characters' : ''
                                                    );
                                                }}
                                                error={!!attentionContactNameError}
                                                helperText={attentionContactNameError}
                                                size="small"
                                            />
                                        </Grid>
                                        <Grid item xs={12} sm={5.5} md={5.5} style={{ paddingTop: '10px', display: 'inline-flex' }}>
                                            <TextField
                                                sx={{ width: '26ch' }}
                                                placeholder="Phone Number"
                                                value={attentionContactPhone}
                                                onChange={(e) => {
                                                    const val = e.target.value.replace(/[^\d\s+()]/g, '');

                                                    setAttentionContactPhone(val);

                                                    setAttentionContactPhoneError(
                                                        val.replace(/\D/g, '').length > 20
                                                            ? 'Phone number must not exceed 20 digits'
                                                            : ''
                                                    );
                                                }}
                                                error={!!attentionContactPhoneError}
                                                helperText={attentionContactPhoneError}
                                                size="small"
                                            />
                                        </Grid>
                                        <Grid item xs={12} sm={0.5} md={0.5} style={{ paddingTop: '10px', display: 'inline-flex', paddingLeft: '2px' }}>
                                            <Tooltip title="Only numerical value allowed" style={{ padding: '0px', height: '36px' }}>
                                                <IconButton>
                                                    <InfoOutlinedIcon fontSize="small" />
                                                </IconButton>
                                            </Tooltip>
                                        </Grid>
                                        <Grid item xs={12} sm={6} md={6} style={{ paddingTop: '10px', display: 'inline-flex', paddingLeft: 0 }}>
                                            <Input
                                                sx={{ width: '24.5ch' }}
                                                placeholder='Email'
                                                value={attentionContactEmail}
                                                onChange={(e: any) => {
                                                    setAttentionContactEmail(e.target.value);
                                                    const emailVal = e.target.value;
                                                    if (emailVal.length > 100) {
                                                        setAttentionContactEmailError('Email cannot exceed 100 characters');
                                                    } else if (emailVal && !/\S+@\S+\.\S+/.test(emailVal)) {
                                                        setAttentionContactEmailError('Invalid email address');
                                                    } else {
                                                        setAttentionContactEmailError('');
                                                    }
                                                }}
                                                error={!!attentionContactEmailError}
                                                helperText={attentionContactEmailError}
                                                size="small"
                                            />
                                        </Grid>
                                        <Grid item xs={12} sm={5.5} md={5.5} style={{ paddingTop: '10px', display: 'inline-flex' }}>
                                            <TextField
                                                sx={{ width: '26ch' }}
                                                placeholder="Mobile Number"
                                                value={attentionContactMobile}
                                                onChange={(e) => {
                                                    const val = e.target.value.replace(/[^\d\s+()]/g, '');

                                                    setAttentionContactMobile(val);

                                                    setAttentionContactMobileError(
                                                        val.replace(/\D/g, '').length > 20
                                                            ? 'Mobile number must not exceed 20 digits'
                                                            : ''
                                                    );
                                                }}
                                                error={!!attentionContactMobileError}
                                                helperText={attentionContactMobileError}
                                                size="small"
                                            />
                                        </Grid>
                                    </Grid>
                                )}
                            </Grid>
                            {searchparams.get('client') === 'new' ? <>
                                <Grid item xs={4} sm={3} md={3} style={{ paddingTop: '8px' }}>
                                    <InputLabel>
                                        <Typography variant="subtitle1" gutterBottom>
                                            Deliver To Email Id <span style={{ color: "#f00" }}> *</span>
                                        </Typography>
                                    </InputLabel>
                                </Grid>
                                <Grid item xs={8} sm={9} md={9} style={{ paddingTop: 16, paddingLeft: 30 }}>
                                    <Input
                                        id="outlined-adornment-weight"
                                        type="email"
                                        sx={{ width: { xs: '14ch', sm: '38ch', md: '51ch' } }}
                                        value={emailId}
                                        onChange={(event: any) => handleEmailIdChange(event.target.value)}
                                        onBlur={(event: any) => hanldeEmailOnBlur(event.target.value)}
                                        size="small"
                                        error={!!emailError.required || !!emailError.validError}
                                        helperText={emailError.required || emailError.validError}
                                    />
                                </Grid>
                                <Grid item xs={4} sm={3} md={3} style={{ paddingTop: '8px' }}>
                                    <InputLabel>
                                        <Typography variant="subtitle1" gutterBottom>
                                            Phone Number
                                        </Typography>
                                    </InputLabel>
                                </Grid>
                                <Grid item xs={8} sm={9} md={9} style={{ paddingTop: 16, paddingLeft: 30 }}>
                                    <Input
                                        id="outlined-adornment-weight"
                                        type="tel"
                                        sx={{ width: { xs: '14ch', sm: '38ch', md: '51ch' } }}
                                        value={deliverToPhone}
                                        onChange={(event: any) => handleDeliverToPhoneChange(event.target.value)}
                                        onBlur={(event: any) => hanldeDeliverToPhoneOnBlur(event.target.value)}
                                        size="small"
                                        error={!!deliverToPhoneError.required || !!deliverToPhoneError.validError}
                                        helperText={deliverToPhoneError.required || deliverToPhoneError.validError}
                                    />
                                </Grid>
                            </>
                                : null}
                            <Grid item xs={4} sm={3} md={3} style={{ paddingTop: '10px' }}>
                                <InputLabel>
                                    <Typography variant="subtitle1" gutterBottom>
                                        Service Contact
                                    </Typography>
                                </InputLabel>
                            </Grid>
                            <Grid item xs={8} sm={9} md={9} style={{ paddingTop: '14px', paddingLeft: '30px' }}>
                                <RadioGroup
                                    row
                                    aria-labelledby="demo-row-radio-buttons-group-label"
                                    name="controlled-radio-buttons-group"
                                    value={isServiceContact}
                                    onChange={handleServiceContact}
                                >
                                    <FormControlLabel value={false} control={<Radio />} label={isClient === 'exist' ? 'Client Manager' : 'Logged In User'} />
                                    <FormControlLabel value={true} control={<Radio />} label="Custom" />
                                </RadioGroup>
                                {isServiceContact ?
                                    <Grid container spacing={2}
                                        sx={{ width: { xs: '14ch', sm: '38ch', md: '51.5ch' }, marginTop: "15px", border: '1px solid #ddd', padding: '20px', marginLeft: '0px' }}
                                    >
                                        <Grid item xs={12} sm={6} md={6} style={{ paddingTop: '10px', display: 'inline-flex', paddingLeft: 0 }}>
                                            <Input
                                                id="outlined-adornment-weight"
                                                sx={{ width: '24.5ch' }}
                                                name='name'
                                                placeholder='Name *'
                                                value={contactName}
                                                onChange={(event: any) => {
                                                    setContactName(event.target.value);
                                                    validateNameInput(event.target.value);
                                                }}
                                                onKeyDown={(event) => {
                                                    if (!ALPHA_NUMERIC_DASH_REGEX.test(event.key)) {
                                                        event.preventDefault();
                                                    }
                                                }}
                                                error={!!nameError.required || !!nameError.htmlError}
                                                helperText={nameError.required || nameError.htmlError}
                                                required={true}
                                                size="small"
                                            />
                                        </Grid>
                                        <Grid item xs={12} sm={5.5} md={5.5} style={{ paddingTop: '10px', display: 'inline-flex' }}>
                                            <TextField
                                                id="outlined-adornment-weight"
                                                sx={{ width: '26ch', height: '38px' }}
                                                name="phoneNo"
                                                placeholder="Phone Number"
                                                value={contactPhoneNo}
                                                onChange={handlePhoneNo}
                                                inputProps={{
                                                    maxLength: 30,
                                                }}
                                                error={!!contactPhoneNoError}
                                                helperText={contactPhoneNoError}
                                                size="small"
                                            />

                                        </Grid>
                                        <Grid item xs={12} sm={0.5} md={0.5} style={{ paddingTop: '10px', display: 'inline-flex', paddingLeft: '2px' }}>
                                            <Tooltip title="Only numerical value and + (plus) sign allowed" style={{ padding: '0px', height: '36px' }}>
                                                <IconButton>
                                                    <InfoOutlinedIcon fontSize="small" />
                                                </IconButton>
                                            </Tooltip>
                                        </Grid>
                                        <Grid item xs={12} sm={12} md={12} style={{ paddingTop: '10px', display: 'inline-flex', paddingLeft: 0 }}>
                                            <Input
                                                id="outlined-adornment-weight"
                                                sx={{ width: { xs: '14ch', sm: '38ch', md: '59.5ch' } }}
                                                name='emailID'
                                                placeholder='Email ID *'
                                                value={contactEmailId}
                                                onChange={(event: any) => handleServiceEmailId(event)}
                                                error={!!serviceEmail.required || !!serviceEmail.htmlError || !!isContactEmailIdError}
                                                helperText={serviceEmail.required || serviceEmail.htmlError || isContactEmailIdError}
                                                required={true}
                                                size="small"
                                            />
                                        </Grid>
                                    </Grid>
                                    : null}
                            </Grid>
                            <Grid item xs={4} sm={3} md={3} style={{ paddingTop: '10px' }}>
                                <InputLabel>
                                    <Typography variant="subtitle1" gutterBottom>
                                        Signature Contact
                                    </Typography>
                                </InputLabel>
                            </Grid>
                            <Grid item xs={8} sm={9} md={9} style={{ paddingTop: '14px', paddingLeft: '30px' }}>
                                <FormControl
                                    size="small"
                                    error={!!signatureAsmError}
                                    sx={{ width: { xs: '14ch', sm: '38ch', md: '51ch' } }}
                                >
                                    <Select
                                        value={selectedAsmId}
                                        onChange={handleAsmSelect}
                                        displayEmpty
                                        sx={{ fontSize: 12 }}
                                    >
                                        {asmOptions.map((option: any) => (
                                            <MenuItem key={option.id} value={option.id}>
                                                {option.firstname} {option.lastname}{option.designation ? ` - ${option.designation}` : ''}
                                            </MenuItem>
                                        ))}
                                    </Select>
                                    <FormHelperText>{signatureAsmError}</FormHelperText>
                                </FormControl>
                            </Grid>
                            <Grid item xs={4} sm={3} md={3} style={{ paddingTop: '16px' }}>
                                <InputLabel>
                                    <Typography variant="subtitle1" gutterBottom>
                                        Description
                                    </Typography>
                                </InputLabel>
                            </Grid>
                            <Grid item xs={8} sm={9} md={9} style={{ paddingTop: '16px', paddingLeft: 30 }}>
                                <Input
                                    id="outlined-multiline-static"
                                    multiline
                                    rows={4}
                                    value={description}
                                    inputProps={{ maxLength: 200 }}
                                    onChange={(e: any) => setDescription(e.target.value)}
                                    sx={{
                                        width: { xs: '14ch', sm: '38ch', md: '51ch' }
                                    }}
                                />
                            </Grid>
                        </>}
                    </Grid>
                </ClickAwayListener>
            </Card>
            <InputLabel>
                <Typography variant="subtitle1" gutterBottom>
                    Some of the analysis have a short holding time, for details <Link href="#">Click Here</Link>
                </Typography>
            </InputLabel>
            <AssociateFees
                getAssociateFee={updateAssociateFee}
                updateAssociateFeeQuote={updateAssociateFeeQuote}
                getChargesStatus={chargesStatus}
                isEditSection={isEdit}
                paramId={paramId}
                getLabList={getLabList}
                getAssociateId={getAssociateId}
                setCourierChargeList={setCourierChargeList}
                isClient={isClient}
            />
            <AnalysisFees
                getPriceListId={getPriceListId}
                analysisFeeStatus={analysisFeeStatus}
                analysisFeeResponse={analysisFeeResponse}
                updateAddStatus={updateAddStatus}
                quoteNumber={quoteNumber}
                quoteId={quoteId}
                resultTableStatus={resultTableStatus}
                parentGetRow={parentGetRow}
                summaryStatus={summaryStatus}
                getPriceTableResult={getPriceTableResult}
                resultTableData={priceTableResult || []}
                summaryUpdateStatus={summaryUpdateStatus}
                showSummaryTable={showSummaryTable}
                resultTableNames={resultTableNames}
                isEdit={isEdit}
                setAnalysisFeeResponse={setAnalysisFeeResponse}
                handleSubmit={handleSubmit}
                analysisGridLoad={analysisGridLoad}
                isRequired={(isClient === 'exist') ? isRequired : isNewClient}
                errorCheck={errorCheck}
                paramId={paramId}
                loading={loading}
                saveAllTrigger={saveAllTrigger}
            />
            <ShareWithCustomer
                open={isShareWithCustomer}
                onClose={() => setIsShareWithCustomer(false)}
                userInfo={userInfo}
                shareWithCustomer={clientName}
                handleShareWithCustomer={handleShareWithCustomer}
                isSuccessMsg={isSuccessMsg}
            />
            <ApproveConfirmationBox
                open={editApproveMessage}
                onClose={() => setEditApproveMessage(false)}
                updateQuoteApi={initialQuoteSubmit}
                updateItemStatus={updateItemStatus}
                message="This Quote is already approved! Do you want to create a new version?"
                mode="generate"
            />
            <InlineButton>
                <InlineButtonSize>
                    <ButtonAlignLeft>
                        <Button
                            variant="outlined"
                            color="primary"
                            onClick={() => navigate('/home/viewQuote')}
                            startIcon={<ArrowBackIcon />}
                        >
                            Back
                        </Button> &nbsp;&nbsp;
                        <Button
                            variant="outlined"
                            color="primary"
                            onClick={handleShareClick}
                            disabled={isProd ? true : !submitCheck}
                            startIcon={<IosShareOutlinedIcon />}
                        >
                            Share With Customer
                        </Button>
                    </ButtonAlignLeft>
                </InlineButtonSize>
                <InlineButtonSize>
                    <ButtonAlign>
                        <Button
                            variant="outlined"
                            color="primary"
                            onClick={handleGenerate}
                            disabled={!submitCheck}
                            startIcon={<ArticleOutlinedIcon />}
                        >
                            Generate PDF
                        </Button> &nbsp;&nbsp;
                        <Tooltip title={!submitCheck ? "Please clear the errors then proceed" : ""} arrow>
                            <span>
                                <Button
                                    variant="contained"
                                    color="primary"
                                    onClick={handleSaveDraft}
                                    disabled={!submitCheck}
                                    startIcon={<SaveAsOutlinedIcon />}
                                >
                                    Save Draft
                                </Button>
                            </span>
                        </Tooltip>
                    </ButtonAlign>
                </InlineButtonSize>
            </InlineButton>
            <Stack sx={{ width: '100%', marginTop: 2 }} spacing={2}>
                <Snackbar open={quoteSuccess} autoHideDuration={4000} onClose={() => quoteMessageClose(true)}>
                    <Alert severity="success" onClose={() => quoteMessageClose(true)}><b>Quote saved successfully!</b></Alert>
                </Snackbar>
                <Snackbar open={duplicateError.status} autoHideDuration={3000} onClose={() => quoteMessageClose(false)}>
                    <Alert severity="warning" onClose={() => quoteMessageClose(false)}><b>{duplicateError.message}</b></Alert>
                </Snackbar>
                <Snackbar open={isSuccessMsg} autoHideDuration={3000} onClose={() => setIsSuccessMsg(false)}>
                    <Alert severity="success" onClose={() => setIsSuccessMsg(false)}><b>Mail Sent Successfully!</b></Alert>
                </Snackbar>
                <Snackbar open={downloadSuccess} autoHideDuration={3000} onClose={() => setDownloadSuccess(false)}>
                    <Alert severity="success" onClose={() => setDownloadSuccess(false)}><b>Downloading the report!</b></Alert>
                </Snackbar>
                <Snackbar open={isAssociateError} autoHideDuration={3000} onClose={() => setIsAssociateError(false)}>
                    <Alert severity="warning" onClose={() => setIsAssociateError(false)}><b>Update failed in the Associated fee section!</b></Alert>
                </Snackbar>
                <Snackbar open={error} autoHideDuration={6000} onClose={() => setError(false)}>
                    <Alert onClose={() => setError(false)} severity="warning"><b>{errorMessage}</b></Alert>
                </Snackbar>
                <Snackbar open={addTestStatus.status} autoHideDuration={3000} onClose={() => setAddTestStatus({ status: false, message: '' })}>
                    <Alert severity="success" onClose={() => setAddTestStatus({ status: false, message: '' })}><b>{addTestStatus.message}</b></Alert>
                </Snackbar>
                <Snackbar open={commonError.open} autoHideDuration={3000} onClose={() => setCommonError({ open: false, message: '' })}>
                    <Alert severity="error" onClose={() => setCommonError({ open: false, message: '' })}><b>{commonError.message}</b></Alert>
                </Snackbar>
            </Stack>
        </div>
    );
}
